import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['educationPopovers'] = [],
  action: Action,
): RootState['educationPopovers'] {
  switch (action.type) {
    case 'CLOSE_ALL_POPOVERS': {
      return []
    }

    case 'OPEN_POPOVER': {
      return [...state, action.payload]
    }

    case 'CLOSE_POPOVER': {
      return state.filter((type) => type !== action.payload)
    }

    case 'SWAP_POPOVER': {
      return [...state.filter((type) => type !== action.payload.close), action.payload.open]
    }

    default:
      return state
  }
}
